import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormGroup, FormControl, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/router';
import * as i3 from 'app-services-library';
import * as i4 from 'reference-library';
import * as i5 from '@angular/common';
import * as i6 from 'primeng/radiobutton';
import * as i7 from 'primeng/inputswitch';
import * as i8 from 'primeng/dropdown';
import { PrimengLibraryModule } from 'primeng-library';

class VdEadLibraryService {
    constructor() { }
}
VdEadLibraryService.ɵfac = function VdEadLibraryService_Factory(t) { return new (t || VdEadLibraryService)(); };
VdEadLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: VdEadLibraryService, factory: VdEadLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdEadLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function VdEadLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4, "Do you want to apply for Employment Authorization Document?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵelementStart(6, "p-inputSwitch", 17);
    i0.ɵɵlistener("onChange", function VdEadLibraryComponent_div_2_Template_p_inputSwitch_onChange_6_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.handleChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function VdEadLibraryComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵtext(3, "For Whom");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-dropdown", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r1.dependentList)("readonly", true);
} }
function VdEadLibraryComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "label", 12);
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵtext(3, "Receipt Number of H1-B Spouse's most recent I-797 Notice for Form I-129");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r2.inputData && !ctx_r2.inputData.visatype.includes("H4"));
} }
class VdEadLibraryComponent {
    constructor(fb, router, parentFor, appServicesLibraryService, referenceLibraryService) {
        this.fb = fb;
        this.router = router;
        this.parentFor = parentFor;
        this.appServicesLibraryService = appServicesLibraryService;
        this.referenceLibraryService = referenceLibraryService;
        this.group = new FormGroup({});
        this.showEADContentSection = false;
        this.dependentList = [];
        this.showReceiptNumSection = true;
    }
    ngOnInit() {
        var _a;
        this.userType = sessionStorage.getItem('userTypeRole');
        const jsonInput = this.inputData && this.inputData.jsonInput ? this.inputData.jsonInput : null;
        if (jsonInput && jsonInput.applicantsList && jsonInput.applicantsList.length > 0) {
            this.dependentList = jsonInput.applicantsList.map(x => {
                return Object.assign(Object.assign({}, x), { displayName: `${x.firstName} ${x.lastName} - ${x.relationshipName}` });
            });
        }
        else {
            if (jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant) {
                const primaryApplicantObj = Object.assign(Object.assign({}, jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant), { displayName: `${jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant.firstName} ${jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant.lastName} - ${jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant.relationshipName}` });
                this.dependentList.push(primaryApplicantObj);
            }
        }
        this.referenceLibraryService.translateArray(this.dependentList, 'displayName')
            .then(translated => {
            this.dependentList = translated;
        })
            .catch(error => console.error("Translation error:", error));
        let fromGrpName = Object.assign(this.groupName);
        let primaryApplicantId;
        if (this.inputData.petitionType === 'EAD') {
            primaryApplicantId = (_a = jsonInput === null || jsonInput === void 0 ? void 0 : jsonInput.primaryApplicant) === null || _a === void 0 ? void 0 : _a.id;
        }
        else {
            primaryApplicantId = this.dependentList.find(item => item.isPrimaryApplicant) ? (this.dependentList.find(item => item.isPrimaryApplicant)).id : null;
        }
        this.showReceiptNumSection = this.inputData && this.inputData.immigrationClassification && ['TEMPPROTSTATI821'].includes(this.inputData.immigrationClassification) ? false : true;
        this.group.addControl(fromGrpName, new FormGroup({
            areYouApplyEAD: new FormControl(this.inputParams.value && this.inputParams.value.areYouApplyEAD ? this.inputParams.value.areYouApplyEAD : (this.inputData && this.inputData.petitionType === 'EAD') ? true : false),
            permissionType: new FormControl(this.inputParams.value && this.inputParams.value.permissionType ? this.inputParams.value.permissionType : null),
            familyId: new FormControl(this.inputParams.value && this.inputParams.value.familyId ? this.inputParams.value.familyId : primaryApplicantId),
            isPreviouslyFiled: new FormControl(this.inputParams.value && this.inputParams.value.isPreviouslyFiled ? this.inputParams.value.isPreviouslyFiled : false),
            isSocialSecurityCardIssued: new FormControl(this.inputParams.value && this.inputParams.value.isSocialSecurityCardIssued ? this.inputParams.value.isSocialSecurityCardIssued : false),
            i797ReceiptNumber: new FormControl(this.inputParams.value && this.inputParams.value.i797ReceiptNumber ? this.inputParams.value.i797ReceiptNumber : null)
        }));
        // console.log("this.group component level", this.group);
        // this.inputParams.groupElementProperty.whenTextAreaShown = 'on';
        //  this.showTextAreaSection = this.inputParams.value && this.inputParams.value.switch_field ? true : false;
        this.showEADContentSection = this.inputParams.value && this.inputParams.value.areYouApplyEAD ? true : (this.inputData && this.inputData.petitionType === 'EAD') ? true : false;
        this.disableFormControl();
        if (this.inputData) {
            this.toggleInputFields();
        }
    }
    toggleInputFields() {
        // console.log(this.inputData.stepStatusCode)
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
        }
        else {
            this.group.enable();
        }
    }
    disableFormControl() {
        let fromGrpName = Object.assign(this.groupName);
        const eadGroupCtrl = this.group.controls[fromGrpName];
        if (eadGroupCtrl) {
            Object.keys(eadGroupCtrl.controls).forEach((key) => {
                //  console.log("keys ",typeof(key));
                if (!['areYouApplyEAD'].includes(key)) {
                    if (this.showEADContentSection) {
                        eadGroupCtrl.controls[key].enable();
                    }
                    else {
                        eadGroupCtrl.controls[key].disable();
                    }
                }
            });
        }
    }
    ngOnChanges() {
        // console.log('child Label', this.sublabel);
        // this.subText =  this.sublabel;
    }
    handleChange($event) {
        // console.log("$event", $event);
        this.showEADContentSection = $event.checked;
        this.disableFormControl();
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
}
VdEadLibraryComponent.ɵfac = function VdEadLibraryComponent_Factory(t) { return new (t || VdEadLibraryComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.FormGroupDirective), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService), i0.ɵɵdirectiveInject(i4.ReferenceLibraryService)); };
VdEadLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdEadLibraryComponent, selectors: [["vd-ead-library"]], inputs: { validation: "validation", readonly: "readonly", sublabel: "sublabel", groupElementProperty: "groupElementProperty", groupName: "groupName", group: "group", inputParams: "inputParams", inputData: "inputData" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ]), i0.ɵɵNgOnChangesFeature], decls: 28, vars: 5, consts: [[3, "formGroup"], [1, "text-field", 3, "formGroupName"], ["class", "row mt-2", 4, "ngIf"], [1, "row"], [1, "label-cls", "pl-3"], [1, "common-bene-class-for-translation"], [1, "row", "pl-3", "mt-2"], ["formControlName", "permissionType", "value", "INITPERM", "label", "Initial Permission", 1, "common-bene-class-for-translation"], ["formControlName", "permissionType", "value", "RENEWPERM", "label", "Renewal of Permission", 1, "ml-4", "common-bene-class-for-translation"], [1, "row", "mt-2"], ["class", "col-4", 4, "ngIf"], [1, "col-10"], [1, "label-cls"], [1, "col-1"], ["name", "isPreviouslyFiled", "formControlName", "isPreviouslyFiled", 1, "pl-2"], ["name", "isSocialSecurityCardIssued", "formControlName", "isSocialSecurityCardIssued", 1, "pl-2"], ["class", "row pl-3 mt-2", 4, "ngIf"], ["name", "areYouApplyEAD", "formControlName", "areYouApplyEAD", 1, "pl-2", 3, "onChange"], [1, "col-4"], [1, "label-cls", "required"], ["formControlName", "familyId", "name", "familyId", "optionLabel", "displayName", "optionValue", "id", "placeholder", "Select Applicant", 3, "options", "readonly"], ["type", "text", "formControlName", "i797ReceiptNumber", 1, "form-control", "col-4", "mt-2", 3, "disabled"]], template: function VdEadLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, VdEadLibraryComponent_div_2_Template, 7, 0, "div", 2);
        i0.ɵɵelementStart(3, "div");
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "label", 4);
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵtext(7, "Applying For");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelement(9, "p-radioButton", 7);
        i0.ɵɵelement(10, "p-radioButton", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵtemplate(12, VdEadLibraryComponent_div_12_Template, 5, 2, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "label", 12);
        i0.ɵɵelementStart(16, "span", 5);
        i0.ɵɵtext(17, "Have you previously filed I-765?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 13);
        i0.ɵɵelement(19, "p-inputSwitch", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 9);
        i0.ɵɵelementStart(21, "div", 11);
        i0.ɵɵelementStart(22, "label", 12);
        i0.ɵɵelementStart(23, "span", 5);
        i0.ɵɵtext(24, "Do you want the SSA to issue a Social Security Card?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 13);
        i0.ɵɵelement(26, "p-inputSwitch", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(27, VdEadLibraryComponent_div_27_Template, 5, 1, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.groupName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.petitionType) != "EAD");
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", (ctx.dependentList == null ? null : ctx.dependentList.length) > 0);
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("ngIf", ctx.showReceiptNumSection);
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormGroupName, i5.NgIf, i6.RadioButton, i1.NgControlStatus, i1.FormControlName, i7.InputSwitch, i8.Dropdown, i1.DefaultValueAccessor], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdEadLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'vd-ead-library',
                templateUrl: 'vd-ead-library.component.html',
                styleUrls: ['vd-ead-library.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.Router }, { type: i1.FormGroupDirective }, { type: i3.AppServicesLibraryService }, { type: i4.ReferenceLibraryService }]; }, { validation: [{
            type: Input
        }], readonly: [{
            type: Input
        }], sublabel: [{
            type: Input
        }], groupElementProperty: [{
            type: Input
        }], groupName: [{
            type: Input
        }], group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }] }); })();

class VdEadLibraryModule {
}
VdEadLibraryModule.ɵfac = function VdEadLibraryModule_Factory(t) { return new (t || VdEadLibraryModule)(); };
VdEadLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdEadLibraryModule });
VdEadLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdEadLibraryModule, { declarations: [VdEadLibraryComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [VdEadLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdEadLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [VdEadLibraryComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [VdEadLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-ead-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdEadLibraryComponent, VdEadLibraryModule, VdEadLibraryService };
//# sourceMappingURL=vd-ead-library.js.map
